// extracted by css-extract-rspack-plugin
module.exports =  {"separator":"CorrectionsDialog__separator___B3UW6"};